import { useParams } from "react-router-dom";

import ContractorExternalUploadView from "../views/ContractorExternalUploadView/ContractorExternalUploadView";

export default function ContractorExternalUpload() {
	const { contractorId } = useParams();

	return <ContractorExternalUploadView contractorId={contractorId} />;
}
